import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import { type ComponentPropsWithoutRef } from 'react';

import { useDialog } from '@repo/ui/Dialog/DialogRoot';

import s from './DialogFooter.module.css';

export type DialogFooterProps = ComponentPropsWithoutRef<'footer'> & {
  as?: 'div' | 'footer';
  asChild?: boolean;
  className?: string;
};

export const dialogFooterVariants = cva(s.footer, {
  variants: {
    variant: {
      compact: s.compactVariant,
      standard: s.standardVariant,
    },
  },
});

export const DialogFooter = (props: DialogFooterProps) => {
  const { as = 'footer', asChild, children, className, ...attrs } = props;
  const { variant } = useDialog();

  const Component = asChild ? Slot : as;

  return (
    <Component
      className={clsx(dialogFooterVariants({ variant }), className)}
      {...attrs}
    >
      {children}
    </Component>
  );
};
